import { withStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PF2MTabs from '~/components/PF2MTabs';
import { useDispatch } from 'react-redux';
import styles from './styles';
import { getEquipmentGroups, getEquipments, getEquipmentTypes } from '~/store/nref/actions';
import AnomalyTab from './AnomalyTab';

const AnomalyControl = () => {
  const dispatch = useDispatch();
  const [loadedData, setLoadedData] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0);

  const { t: translate } = useTranslation();

  const tabs = [
    { key: 0, label: translate('common:Anomaly') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  useEffect(() => {
    if (!loadedData) {
      dispatch(getEquipments());
      dispatch(getEquipmentTypes());
      dispatch(getEquipmentGroups());
      setLoadedData(true);
    }
  }, [loadedData, dispatch]);

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        hideSyncButton
        style={{ marginTop: '5px' }}
      >
        {tabs}
      </PF2MTabs>

      {selectedTab === 0 ? <AnomalyTab /> : null}
    </>
  );
};

export default withStyles(styles)(AnomalyControl);
